import { Page } from 'modules/layout/components/Page';
import { useTranslation } from 'modules/i18n/hooks/useTranslation';

import { BILLING_TAB_INDEX, PLANS_TAB_INDEX } from './constants';
import { BillingTab } from './components/BillingTab';
import { BillingTabs } from './components/BillingTabs';
import { pageWithBillingTabsTr } from './translation';
import { useBillingTabs } from './hooks/useBillingTabs';
import { usePageWithBillingTabsStyles } from './usePageWithBillingTabsStyles';

export interface PageWithBillingTabsProps {
  children: React.ReactNode;
  hasTabs?: boolean;
}

export const PageWithBillingTabs = ({
  children,
  hasTabs = true,
}: PageWithBillingTabsProps) => {
  const { keys, t } = useTranslation(pageWithBillingTabsTr);

  const { classes } = usePageWithBillingTabsStyles();

  const { onChange, value } = useBillingTabs();

  return (
    <Page classes={classes}>
      {hasTabs && (
        <BillingTabs onChange={onChange} value={value}>
          <BillingTab label={t(keys.billing)} value={BILLING_TAB_INDEX} />
          <BillingTab label={t(keys.plans)} value={PLANS_TAB_INDEX} />
        </BillingTabs>
      )}
      {children}
    </Page>
  );
};
